import logo from './springwiz-logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Springwiz Solutions Private Limited.
        </p>
        <p>
          Coming Soon...
        </p>
      </header>
    </div>
  );
}

export default App;
